import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Icon, Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LanguageSelector from '../../../LanguageSelector';
import styles from '../../responsiveContainer.module.scss';

const MenuItemContainer = ({ node, onNavigate, onNavigateBack }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  return (
    <div>
      {node && node.title && (
        <Menu.Item
          className={styles.navigateBack}
          as="div"
          onClick={() => {
            onNavigateBack(node);
          }}
        >
          <Icon className={styles.navigateOut} name="arrow left" />
          {t(node.title)}
        </Menu.Item>
      )}
      <div>
        {node.children.map((child) => {
          const isActive = location.pathname.indexOf(child.path) > -1 && !child.children;
          return (
            <Menu.Item
              as={!isActive ? 'a' : 'span'}
              className={styles.subMenuItem}
              key={child.title}
              href={child.path}
              onClick={(e) => {
                e.preventDefault();
                if (!isActive) {
                  onNavigate(child);
                }
              }}
            >
              {t(child.title)}

              <LanguageSelector
                sideBarItem={child.title}
                selectedLanguage={i18n.language}
                onLanguageChange={(ln) => i18n.changeLanguage(ln)}
              />

              {child.children && <ArrowForwardIosIcon className={styles.navigateTo} />}
              {isActive && <Icon className={styles.checkedIcon} name="check" />}
            </Menu.Item>
          );
        })}
      </div>
      {/* Uncomment in the future, when authentication is ready */}
      {/* <div className={styles.userAccountBox}> */}
      {/*  {isAuth ? ( */}
      {/*    <LogOutButtonDropDownItems clickHandler={handleClose} /> */}
      {/*  ) : ( */}
      {/*    <LoginButton */}
      {/*      handleClick={() => { */}
      {/*        handleClose(); */}
      {/*        dispatch(showLogin()); */}
      {/*        window.scrollTo(0, 0); */}
      {/*      }} */}
      {/*    /> */}
      {/*  )} */}
      {/* </div> */}
    </div>
  );
};

MenuItemContainer.propTypes = {
  onNavigate: PropTypes.func.isRequired,
  onNavigateBack: PropTypes.func.isRequired,
  node: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        header: PropTypes.string,
        icon: PropTypes.element,
        links: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            path: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
};

MenuItemContainer.defaultProps = {
  node: { children: [] },
};

export default MenuItemContainer;
